import {ChangeDetectionStrategy, Component} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";


@Component({
    selector: "section-inbound-summaraized-allocations-list",
    template: `
        <h1 class="container-heading">Allocations in transit summarized</h1>
        <mat-card>
            <mat-card-content>
                <section-allocations-list type="inbound" [summarized]="true" [state]="state"></section-allocations-list>
            </mat-card-content>
        </mat-card>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InboundSummarizedAllocationsListComponent implements Base.IComponent {

    public readonly state: Base.IState;

    public constructor() {
    }


    public ngConfig(): Base.IConfig {
        return {
            name: "allocations-in-transit-summarized",
            actions: {
                "browse": ["browse_inventory_allocations"]
            }
        };
    }
}
